import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getOtp, resetOtpPage } from "../../actions/auth-action";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import "./ForgetPass.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";

const ForgetPass = (props) => {
  const { getOtp, resetOtpPage } = props;

  const [email, setEmail] = useState("");

  const { getOtpStart, getOtpSuccess, getOtpError } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();

  useEffect(() => {
    if (getOtpSuccess) {
      setTimeout(() => {
        history.push("/reset-pass");
      }, 300);
    }
  }, [getOtpSuccess]);

  useEffect(() => {
    resetOtpPage();
    return () => {
      resetOtpPage();
    };
  }, []);

  const clickGetOtp = (e) => {
    e.preventDefault();
    getOtp(email);
  };

  return (
    <>
      <Header />
      <Container fluid>
        <Row className="justify-content-center mt-5 forget-pass">
          <Col className="forget-pass-col">
            <div className="p-4">
              <h6 className="header-text text-center">Reset Password</h6>
              <Form className="mt-5">
                <Form.Group className="ch-form">
                  <Form.Control
                    type="email"
                    placeholder="Input your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
                <Button
                  type="submit"
                  variant="success"
                  onClick={clickGetOtp}
                  className="ch-button mt-4"
                >
                  {getOtpStart ? "Sending..." : "Get OTP"}
                </Button>
                <Alert
                  show={getOtpSuccess || getOtpError != null}
                  variant={getOtpError ? "danger" : "success"}
                  className="mt-3"
                >
                  {" "}
                  {getOtpError || "Otp has been sent!"}
                </Alert>
              </Form>
            </div>
          </Col>
        </Row>
        <Footer />
      </Container>
    </>
  );
};
export default connect(null, { getOtp, resetOtpPage })(ForgetPass);
